/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2018-12-04 18:16:03
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-04-19 16:15:07
 * @Description:  x推d落地页奖励详情页
 */
<template>
  <div class="xtd-box bgc">
    <div :class="{'xtd-reward-container': !isIPad, 'iPad-xtd-reward-container': isIPad}">
      <div :class="{'xtd-reward-container-body': !isIPad, 'iPad-xtd-reward-container-body': isIPad}">
        <div style="padding:28px 0 0;">
          <div class="tab-panel-li">
            <div class="mod">
              <strong class="cityName nopd">{{ $route.query.cityName }}</strong>
            </div>
            <div class="mod">
              <div class="activityTime">{{ $t('sailing.d-api.common.活动时间'/* 活动时间 */) }}</div>
              <div class="modText">{{ $route.query.activityTime }}</div>
            </div>
            <div class="mod nopd">
              <rich-loading v-if="showLoading" :size="16"></rich-loading>
              <strong v-if="ruleTypeName" class="rewardType">{{ ruleTypeName }}<span @click="jumpToRules" class="icon-i"></span></strong>
              <div class="con" style="width:100%;">
                <div class="orlay personLevel" v-if="activityObject.ruleType === 2">
                  <rich-progresss :paramsn="processInfo.levels" :current="processInfo.currentNumber" :content="processInfo.head" :is-subsection="true"></rich-progresss>
                </div>
                <!-- 奖励list start -->
                <ul class="list-wraper list-container" v-if="activityObject.list && activityObject.list.length > 0" style="position:static;">
                  <li class="cell-wrap list-item" :class="itmCls(item)" v-for="(item, index) in activityObject.list" :key="index">
                    <div class="cell-lefts">
                      <p class="cell-title">{{item.phone}}</p>
                      <p class="tag-list">
                        <span class="tagd" v-if="item.initVehicleType">{{item.initVehicleType}}</span>
                      </p>
                    </div>
                    <div class="cell-rights">
                      <span class="status">{{`${item.amount > 0 ? item.amount_display : ''} ${item.subtext}`}}</span>
                    </div>
                    <div class="orlay" v-if="activityObject.ruleType === 1 && ![4, 6].includes(item.status) && item.progressBar.head">
                      <rich-progresss :paramsn="formatProgressInfo(item.progressBar.levels, item.progressBar.currentLevel)" :current="item.progressBar.currentNumber" :content="item.progressBar.head" :is-subsection="true"></rich-progresss>
                    </div>
                    <p class="message" v-if="item.message">{{item.message}}</p>
                  </li>
                </ul>
                <!-- 奖励list end -->
                <div v-if="noData" class="noData">{{ $t('FoodD_Activity_No_activity_fhqd'/*暂无活动参与记录*/) }}</div>
                <div v-if="noMore" class="noMore">{{ $t('soda-d-i18n---没有更多了'/*没有更多了*/) }}</div>
                <div v-if="!noMore && dataBack && !noData" @click="getDetail" class="noMore">{{ $t('FoodD_Activity_Expand_more_VNNc'/*展开更多*/) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getUserInfo, getRiderBackBtn } from '@/common/js/bridge'
import RichProgresss from './richProgress'
import i18nUtil from '@didi/i18n-util'
import { getLocale } from '@didi/gettext'

export default {
  name: 'rewardDetail',
  data () {
    return {
      activityList: [],
      activityFinishList: [],
      value: [0],
      currentCityID: this.$route.query.cityID || '',
      currentCityName: this.$route.query.cityName || '',
      activityGoingInfo: {},
      listInfo: {},
      size: 15,
      offset: -15,
      cancelFetch: false,
      sourceType: null,
      sourceID: null,
      pageNo: 1,
      pageSize: 15,
      noMore: false,
      noData: false,
      dataBack: false,
      showLoading: true
    }
  },
  components: {
    RichProgresss
  },
  async created () {
    if (this.isInDApp) getRiderBackBtn()
    // setTitle(this.gettext('我的奖励'))
    this.getSourceInfo()
      .then((data) => {
        this.getActivityDetail({
          token: this.globalParams.token,
          activityID: this.$route.query.activityID,
          sourceType: 'd',
          sourceID: this.sourceID || 'd',
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }).then((res) => {
          if (!res || !res.list || !res.list.length) {
            if (this.pageNo === 1) {
              this.noData = true
            } else {
              this.noMore = true
            }
          } else {
            if (this.pageNo === 1) {
              this.activityList = res
            } else {
              this.activityList = {
                ...this.activityList,
                list: this.activityList.list.concat(res.list)
              }
            }
            if (res.list.length < this.pageSize) {
              this.noMore = true
            }
          }
          this.showLoading = false
          this.dataBack = true
          this.pageNo = this.pageNo + 1
        })
      })
      .catch(err => {
        const toast = this.$createToast({
          time: 3000,
          txt: err,
          type: 'error'
        })
        toast.show()
      })
  },
  computed: {
    ...mapGetters(['globalParams']),
    activityObject () {
      if (this.activityList && this.activityList.length !== 0) {
        return this.activityList
      } else {
        return []
      }
    },
    processInfo () {
      if (this.activityList && this.activityList.summary) {
        return {
          head: this.activityList.summary.head,
          levels: this.formatProgressInfo(this.activityList.summary.levels, this.activityList.summary.currentLevel),
          currentNumber: this.activityList.summary.currentNumber
        }
      } else {
        return {
          head: {
            top: '',
            bottom: ''
          },
          levels: [{
            mainTitle: '',
            detail: '',
            inProgress: false
          }],
          currentNumber: ''
        }
      }
    },
    ruleTypeName () {
      if (this.activityList && this.activityList.ruleType) {
        if (this.activityList.ruleType === 1) {
          return this.$t('FoodD_Activity_Single_reward_ZrZS'/* 单量奖励 */)
        } else if (this.activityList.ruleType === 2) {
          return this.$t('FoodD_Activity_Number_of_OgKt'/* 人数奖励 */)
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions(['getGlobalInfo', 'getActivityGoingInfo', 'getActivityFinishList', 'getActivityDetail']),
    getDetail () {
      this.getActivityDetail({
        token: this.globalParams.token,
        activityID: this.$route.query.activityID,
        sourceType: 'd',
        sourceID: this.sourceID || 'd',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then((res) => {
        if (!res || !res.list || !res.list.length) {
          if (this.pageNo === 1) {
            this.noData = true
          } else {
            this.noMore = true
          }
        } else {
          if (this.pageNo === 1) {
            this.activityList = res
          } else {
            this.activityList.list = this.activityList.list.concat(res.list)
          }
          if (res.list.length < this.pageSize) {
            this.noMore = true
          }
        }
        this.pageNo = this.pageNo + 1
      })
    },
    jumpToDetail () {
      this.$router.push({
        path: `/d/rewardDetail`
      })
    },
    jumpToRules () {
      this.$router.push({
        path: `/d/detailRules`
      })
    },
    formatTime (prop) {
      return i18nUtil.getTimeFormat({
        timestamp: prop && prop.timestamp * 1000,
        offset: prop && prop.offset,
        locale: getLocale(),
        format: 'YYYY.MM.DD'
      })
    },
    async fetchActivityGoingInfo (data) {
      let res = await this.getActivityGoingInfo(data)
      if (res && res.errno === 0 && res.data) {
        this.activityGoingInfo = res.data
        this.activityList = await this.getActivityDetail({
          token: this.globalParams.token,
          activityID: this.activityGoingInfo.activities[0].activityID,
          sourceType: 'd',
          sourceID: this.sourceID || 'd'
        })
      } else {
        throw res && res.errmsg
      }
    },
    formatProgressInfo (info, current) {
      let tmp = Object.values(info)
      let data = []
      tmp.map((i, d) => {
        data.push({
          detail: i.top + '',
          mainTitle: i.bottom + '',
          // inProgress: (current - 1 === d) ? !!1 : !!0
          inProgress: i.finish,
          value: +i.top
        })
      })
      return data
    },
    getSourceInfo () {
      if (this.isInDApp) {
        return Promise.all([this.getGlobalInfo(), getUserInfo()])
          .then((data) => {
            this.sourceType = 'd'
            this.sourceID = data[1].uid
            return {
              ...data[0],
              ...data[1],
              sourceType: 'd',
              sourceID: data[1].uid
            }
          })
          .catch((err) => {
            console.log('err', err)
          })
      } else if (this.isInBApp || this.isIPad) {
        // 改版后暂不不会进入此分支
        return Promise.all([this.getGlobalInfo()])
          .then((data) => {
            this.sourceType = 'b'
            this.sourceID = data[1].shopId
            return {
              ...data[0],
              ...data[1],
              sourceType: 'b',
              sourceID: data[1].shopId
            }
          })
      }
      return Promise.resolve({})
    },
    itmCls (data) {
      if (this.activityList && this.activityList.ruleType === 1) {
        // 单量阶梯
        switch (data.status) {
          case 1:
          case 2:
          case 3:
          case 4: return 'itm-black'
          case 5:
          case 6:
          case 7: return 'itm-red'
          default: return 'itm-grey'
        }
      } else if (this.activityList.ruleType === 2) {
        // 人数阶梯
        switch (data.status) {
          case 1:
          case 2: return 'itm-green'
          case 3:
          case 4: return 'itm-black'
          case 5:
          case 6:
          case 7: return 'itm-red'
          default: return 'itm-grey'
        }
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="stylus">
@import "~@/common/stylus/base"
@import "~@/common/stylus/mixin"
$conversion = 0.5859375px
body {
  // overflow: hidden;
}
.rich-scroll-wrapper {
  width: 100%
}
.xtd-box {
  height: 100%
}
.bgc {
  background: #fff
  .xtd-reward-container {
    padding-top: 0;
  }
}
.xtd-reward-container {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // overflow-x: scroll;
  // background: #fff;
  font-size: 0.625rem;
  .no-px2rem {
    border-1px(#E5E5E5, 4px, solid)
  }
  .xtd-reward-container-body {
    background: #fff
    padding: 0
    .rich-tab-bar {
      margin: 0 40px
      justify-content: left
      .rich-tab {
        width: 200px;
        flex: none;
        padding-top: 48px;
        padding-bottom: 20px;
        height: 36px;
        font-family: "Aspira Regular";
        font-size: 36px;
        color: #999;
        letter-spacing: 0;
        font-weight: 400;
      }
      .rich-tab_active {
        height: 36px;
        font-family: "Aspira Demi";
        font-size: 36px;
        color: #000;
        letter-spacing: 0;
        font-weight: 500;
      }
    }
    .rich-tab-bar-slider {
      height: 6px;
      transform: scaleY(-1);
      background: #000000;
      border-radius: 10px;
    }
    .rich-tab-panels {
      padding-top: 64px
      .rich-tab-panel {
      }
    }
    .rich-tag-group {
      display: flex;
      justify-content: left;
      overflow-y: scroll;
      padding-bottom: 20px;
      .rich-tag-item-wrapper {
        width: 100%;
        height: auto;
        .rich-tag-item {
          font-family: "Aspira Medium";
          font-size: 28px;
          color: #000;
          font-weight: 400;
          border: none;
          white-space: nowrap;
          min-width: auto;
          padding: 0 24px;
        }
        .rich-tag-item:after {
          background: rgba(0, 0, 0, 0.05);
          border-radius: 12px;
          color: #000;
          font-family: "Aspira Regular";
          font-weight: 400;
          border: none;
        }
        .rich-tag-item.active {
          background: #FFEBE3;
          border-radius: 12px;
          font-weight: 500;
          color: #FF7A45;
          border: none;
        }
        .rich-tag-item.active:after {
          background: #FFEBE3;
          font-weight: 500;
          color: #FF7A45;
          z-index: -1;
        }
      }
      .rich-tag-text {
        white-space: nowrap;
      }
    }
    .nopd {
      padding: 0!important;
    }
    .mod {
      padding: 0 40px;
      strong {
        padding: 0 40px;
        display: block;
        margin-bottom: 8px;
        height: 32px;
        font-family: "Aspira Regular";
        font-size: 32px;
        color: #000;
        font-weight: 400;
      }
      .rewardType {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-bottom: 8px;
        font-size: 40px;
        color: #000;
        font-weight: 600;
        .icon-i {
          display: inline-block
          margin-left: 8px
          width: 32px
          height: 32px
          background: url("../../../assets/images/xtd/icon_i.png") no-repeat
          background-size: 100% 100%
          color: #999
        }
      }
      .cityName {
        margin-bottom: 56px;
        height: 56px;
        font-family: "Aspira Demi";
        font-size: 56px;
        color: #000;
        letter-spacing: 0;
        font-weight: 600;
      }
      .activityTime {
        margin-bottom: 24px;
        height: 24px;
        font-family: "Aspira Regular";
        font-size: 24px;
        color: #999;
        letter-spacing: 0;
        font-weight: 400;
      }
      .modText {
        margin-bottom: 80px;
        font-family: "Aspira Regular";
        font-size: 32px;
        color: #000;
        font-weight: 400;
      }
      .con {
        .noData {
          margin-top: 80px;
          text-align: center;
          font-family: "Aspira Regular";
          font-size: 28px;
          color: #999;
          font-weight: 400;
        }
        .noMore {
          margin-top: 80px;
          padding: 0 0 60px;
          text-align: center;
          font-family: "Aspira Regular";
          font-size: 28px;
          color: #999;
          font-weight: 400;
        }
        display: block;
        .tagd {
          display: inline-block; 
          height: 40px;
          line-height: 40px;
          margin-right: 12px;
          padding: 0;
          font-family: "Aspira Regular";
          font-size: 24px;
          color: #666;
          text-align: left;
          font-weight: 400;
        }
        .orlay {
          padding: 0 40px;
          height: 138px;
          margin-bottom: 50px;
          overflow: hidden;
        }
        .personLevel {
          margin-top: 40px;
          margin-bottom: 56px;
        }
      }
    }
  }
  .xtd-common-income-container {
    margin: 32px;
    border-radius: 12px;
  }
  &-tabbar {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .content {
      display: flex
      margin-top: 52px
      justify-content: space-between
      .item {
        margin: 0 47.5px
        flex: 1
        text-align: center
        .money {
          display: flex;
          justify-content: center;
        }
        .status {
          color: #999
          display: block
          line-height: 28px
          margin-top: 17px
          font-size: 28px;
          line-height: 28px;
          min-width: 260px;
        }
      }
      .item /deep/ .symbol {
        display: inline-block
        font-size: 42px;
        color: #333333;
        line-height: 72px;
        vertical-align: middle
      }
      .item /deep/ .amount {
        display: inline-block
        color: #333333;
        line-height: 72px;
        font-size: 72px;
        font-style: normal
        vertical-align: bottom
      }
    }
  }
  &-body{
    // position: fixed;
    top: 330px;
    left: 0;
    bottom: 0;
    // width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    .rich-progress {
      margin-bottom: 20px;
      .scroll-panel {
        padding-bottom: 20px;
      }
    }
    .cell-wrap {
      position: relative;
      margin: 0;
      padding: 48px 40px 40px;
      border-bottom: 1px solid #E5E5E5;
      .orlay {
        padding: 0!important;
        margin-top: 24px;
        margin-bottom: 10px!important;
      }
      .cell-label {
        font-weight: bold;
        font-size: 28px;
        color: #333333;
        text-align: left;
        line-height: 28px;
      }
      .cell-title {
        font-family: "Aspira Regular";
        font-size: 32px;
        color: #000;
        text-align: left;
        line-height: 32px;
        font-weight: 400;
      }
      .cell-text {
        margin-top: 24px;
        font-family: "Aspira Regular";
        font-size: 28px;
        color: #666666;
        font-weight: 400;
        text-align: left;
        line-height: 28px;
      }
      .cell-value {
        font-size: 32px;
        color: #333;
        text-align: left;
        flex-direction: column;
      }
      &.itm-black {
        .cell-rights .status{
          color: #333333
        }
        .message {
          color: #333
        }
      }
      &.itm-red {
        .cell-rights .status{
          color: #F93F3F
        }
        .message {
          color: #F93F3F
        }
      }
      &.itm-grey {
        .cell-rights .status{
          color: #666
        }
        .message {
          color: #666
        }
      }
      &.itm-green {
        .cell-rights .status{
          color: #1BB17C
        }
        .message {
          color: #1BB17C
        }
      }
      .cell-lefts {
        // margin: 0 40px;
        .tag-list {
          margin: 8px 0 0;
          .tagd {
            display: inline-block; 
            height: 24px;
            line-height: 24px;
            margin-right: 12px;
            padding: 0;
            font-family: "Aspira Regular";
            font-size: 24px;
            color: #666;
            text-align: left;
            font-weight: 400;
          }
        }
      }
      .message {
        margin-top: 28px;
        color: #666;
        font-family: "Aspira Regular";
        font-size: 24px;
        text-align: left;
        line-height: 24px;
        font-weight: 400;
      }
      .cell-rights {
        position: absolute;
        right: 40px;
        top: 48px;
        font-family: "Aspira Regular";
        font-size: 32px;
        color: #000;
        text-align: right;
        font-weight: 400;
      }
    }
    .cell-wrap {
      padding-top: 48px!important;
    }
    .cell-wrap:first-child {
      // padding-top: 0!important;
      // // margin-top: 0;
      // .cell-rights {
      //   top: 0;
      // }
    }
    .line2 {
      width: 100%;
      border-1px(#E5E5E5, 4px, solid)
    }
    .list-wraper {
      position: relative; /*absolute*/
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin-top: 1px;
      margin-bottom: 16px;
    }
  }
}
.iPad-xtd-reward-container {
  display: flex
  height: 100%
  .iPad-xtd-reward-container-tabbar {
    width:426*$conversion
    height:100%
    border-right 1px solid #e5e5e5
    .content {
      margin-top: 120*$conversion
      text-align: center
      .item {
        span {
          display: block
        }
        .money {
          display: flex;
          justify-content: center;
        }
        .amount {
          font-size: 38*$conversion
          color: #333333
          em {
            font-style: normal
          }
        }
        .status {
          font-size: 18*$conversion
          color: #999999
          margin-top: 8*$conversion
        }
      }
      .item /deep/ .symbol {
        font-size: 38*$conversion
        color: #333333
      }
      .item /deep/ .amount {
        font-size: 38*$conversion
        color: #333333
        font-style: normal
      }

      .item + .item {
        margin-top: 170*$conversion
      }
    }
  }
  .iPad-xtd-reward-container-body {
    background: #fff
    flex: 1
    height: 100%
    padding: 0 60*$conversion 0 40*$conversion
    position: relative
    .cell-wrap {
      position: relative;
      margin: 0 40*$conversion;
      padding: 48px 0;
      border-bottom: 1*$conversion solid #E5E5E5;
      .cell-lefts {
        font-size: 0;
        .cell-title {
          font-size: 22*$conversion;
          color: #333333;
          text-align: left;
          line-height: 22*$conversion;
          font-weight: bold;
          display: inline-block;
        }
        .tag-list {
          margin-left: 12*$conversion;
          display: inline-block;
          .tag {
            margin-right: 8*$conversion;
            padding: 6*$conversion 12*$conversion;
            background: rgba(153,153,153,0.08)
            border-radius: 4*$conversion;
            font-size: 18*$conversion;
            color: #999;
            display: inline-block;
          }
        }
      }
      .cell-rights {
        position: absolute;
        top: 24*$conversion;
        right: 0;
        font-size: 22*$conversion;
      }
      .message {
        margin: 8*$conversion 0 5*$conversion;
        font-size: 22*$conversion;
        color: #999;
        font-family: 'Aspira Regular';
      }
      &.itm-black {
        .cell-rights .status{
          color: #333
        }
      }
      &.itm-red {
        .cell-rights .status{
          color: #F93F3F
        }
      }
      &.itm-grey {
        .cell-rights .status{
          color: #999
        }
      }
    }
    .list-wraper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin-top: 1px;
    }
  }
}
</style>
